export default "__VITE_ASSET__e85f8b09__"